//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Berekent de koopsom van een lijfrente op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    koopsom(body: KoopsomInput | null | undefined): Promise<KoopsomOutput> {
        let url_ = this.baseUrl + "/Lijfrente/Koopsom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKoopsom(_response);
        });
    }

    protected processKoopsom(response: Response): Promise<KoopsomOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KoopsomOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KoopsomOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KoopsomOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KoopsomOutput>(null as any);
    }

    /**
     * Berekent de lijfrente-uitkering op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    uitkering(body: UitkeringInput | null | undefined): Promise<UitkeringOutput> {
        let url_ = this.baseUrl + "/Lijfrente/Uitkering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitkering(_response);
        });
    }

    protected processUitkering(response: Response): Promise<UitkeringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitkeringOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitkeringOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitkeringOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UitkeringOutput>(null as any);
    }

    /**
     * Berekent het premiedepot op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    premiedepot(body: PremiedepotInput | null | undefined): Promise<PremiedepotOutput> {
        let url_ = this.baseUrl + "/Premiedepot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPremiedepot(_response);
        });
    }

    protected processPremiedepot(response: Response): Promise<PremiedepotOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiedepotOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PremiedepotOutput>(null as any);
    }

    /**
     * Berekent de periodieke inleg van een vermogensrekening op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    inleg(body: VermogensrekeningInput | null | undefined): Promise<InlegOutput> {
        let url_ = this.baseUrl + "/Vermogensrekening/Inleg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInleg(_response);
        });
    }

    protected processInleg(response: Response): Promise<InlegOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InlegOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InlegOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InlegOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InlegOutput>(null as any);
    }

    /**
     * Berekent de eerste inleg van een vermogensrekening op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    eerste_inleg(body: VermogensrekeningInput | null | undefined): Promise<EersteInlegOutput> {
        let url_ = this.baseUrl + "/Vermogensrekening/EersteInleg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEerste_inleg(_response);
        });
    }

    protected processEerste_inleg(response: Response): Promise<EersteInlegOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EersteInlegOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EersteInlegOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EersteInlegOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EersteInlegOutput>(null as any);
    }

    /**
     * Berekent de periodieke onttrekking van een vermogensrekening op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    onttrekking(body: VermogensrekeningInput | null | undefined): Promise<OnttrekkingOutput> {
        let url_ = this.baseUrl + "/Vermogensrekening/Onttrekking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOnttrekking(_response);
        });
    }

    protected processOnttrekking(response: Response): Promise<OnttrekkingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnttrekkingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnttrekkingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnttrekkingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnttrekkingOutput>(null as any);
    }

    /**
     * Berekent het op te bouwen kapitaal van een vermogensrekening op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    kapitaal(body: VermogensrekeningInput | null | undefined): Promise<KapitaalOutput> {
        let url_ = this.baseUrl + "/Vermogensrekening/Kapitaal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaal(_response);
        });
    }

    protected processKapitaal(response: Response): Promise<KapitaalOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalOutput>(null as any);
    }

    /**
     * Berekent het rendment van een vermogensrekening op basis van de gegeven input.
     * @param body (optional) De input voor de berekening
     * @return Success
     */
    rendement(body: VermogensrekeningInput | null | undefined): Promise<RendementOutput> {
        let url_ = this.baseUrl + "/Vermogensrekening/Rendement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRendement(_response);
        });
    }

    protected processRendement(response: Response): Promise<RendementOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RendementOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RendementOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RendementOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RendementOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * Geeft de foutcodes die in deze Web API kunnen ontstaan.
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export interface BadRequestResult {
    statusCode: number;
}

/** BetalingsTermijnType Geen = 0, Maand = 1, TweeMaanden = 2, Kwartaal = 3, HalfJaar = 6, Jaar = 12, Eenmalig = 99, Week = -7, Dag = -1 */
export enum BetalingsTermijnType {
    Geen = "Geen",
    Maand = "Maand",
    TweeMaanden = "TweeMaanden",
    Kwartaal = "Kwartaal",
    HalfJaar = "HalfJaar",
    Jaar = "Jaar",
    Eenmalig = "Eenmalig",
    Week = "Week",
    Dag = "Dag",
}

/** Bevat de gegevens van een eenmalige inleg of onttrekking. */
export interface EenmaligBedragInput {
    /** Het jaar waarin de eenmalige inleg of onttrekking wordt gedaan. */
    jaar: number;
    /** Bedrag van de eenmalige inleg of onttrekking. */
    bedrag: number;
}

/** Bevat de output van de eerste inleg-berekening. */
export interface EersteInlegOutput {
    resultaat: EersteInlegResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de berekening. */
export interface EersteInlegResultaat {
    /** De berekende eerste inleg van de vermogensrekening. */
    eersteInleg: number;
    /** Het deel van de eerste inleg dat nodig is om het garantiekapitaal op te bouwen. */
    eersteInlegGarantiedeel: number | null;
    /** Bevat de waardeopbouw per maand van een vermogensrekening. */
    waardeopbouwPerMaand: WaardePerMaand[] | null;
}

/** Gegevens van extra stortingen in een bepaald jaar. */
export interface ExtraPremiestortingInJaar {
    /** Jaar van de extra inleg */
    jaar: number;
    /** Bedrag extra inleg */
    bedrag: number;
}

/** Bevat de output van de inleg-berekening. */
export interface InlegOutput {
    resultaat: InlegResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de berekening. */
export interface InlegResultaat {
    /** De berekende inleg van de vermogensrekening. */
    inleg: number | null;
    /** Het deel van de inleg dat nodig is om het garantiekapitaal op te bouwen. */
    inlegGarantiedeel: number | null;
    /** Bevat de waardeopbouw per maand van een vermogensrekening. */
    waardeopbouwPerMaand: WaardePerMaand[] | null;
}

/** Bevat de output van de kapitaal-berekening. */
export interface KapitaalOutput {
    resultaat: KapitaalResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de berekening. */
export interface KapitaalResultaat {
    /** De berekende garantie kapitaal */
    garantiekapitaal: number | null;
    /** Bevat de waardeopbouw per maand van een vermogensrekening. */
    waardeopbouwPerMaand: WaardePerMaand[] | null;
}

/** Bevat de input voor de lijfrente-koopsomberekening. */
export interface KoopsomInput {
    /** Bedrag uitkering per termijn */
    uitkeringLijfrente: number | null;
    uitkeringstermijn: BetalingsTermijnType;
    /** Rendement over het saldo van de lijfrente-rekening. */
    lijfrentetarief: number;
    /** Aantal maanden uitkering */
    uitkeringsduurInMaanden: number | null;
    /** Looptijd extra uitkering (hoog) */
    uitkeringsduurHoogInMaanden: number | null;
    /** Percentage verhouding hoog/laag */
    verhoudingHoogLaag: number | null;
}

/** Bevat de output van de koopsom-berekening van een lijfrente. */
export interface KoopsomOutput {
    resultaat: KoopsomResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de koopsom-berekening van een lijfrente. */
export interface KoopsomResultaat {
    /** Bedrag berekende koopsom */
    koopsom: number;
}

/** Bevat de output van de onttrekking-berekening. */
export interface OnttrekkingOutput {
    resultaat: OnttrekkingResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de berekening. */
export interface OnttrekkingResultaat {
    /** De berekende onttrekking */
    onttrekking: number;
    /** Bevat de waardeopbouw per maand van een vermogensrekening. */
    waardeopbouwPerMaand: WaardePerMaand[] | null;
}

/** Bevat de gegevens van een periodiek bedrag. */
export interface PeriodiekBedragInput {
    /** Looptijd in maanden. */
    looptijdInMaanden: number;
    termijn: BetalingsTermijnType;
    /** Het periodieke bedrag. */
    bedrag: number | null;
}

/** Bevat de gegevens van een periodieke onttrekking. */
export interface PeriodiekeOnttrekkingInput {
    /** Ingangsmaand van de onttrekking. */
    aanvangsmaand: number | null;
    /** Looptijd in maanden. */
    looptijdInMaanden: number;
    termijn: BetalingsTermijnType;
    /** Het periodieke bedrag. */
    bedrag: number | null;
}

/** Invoer voor de premiedepot-berekening. */
export interface PremiedepotInput {
    uitgangspunt: PremiedepotUitgangspunt | null;
    /** Indicatie dat opname uit premiedepot bedoeld is voor lage premies */
    opnameLagePremies: boolean | null;
    /** Indicatie dat opname uit premiedepot bedoeld is voor hoge premies */
    opnameHogePremies: boolean | null;
    /** Indicatie dat opname uit premiedepot bedoeld is voor aanvangsstorting */
    opnameAanvangsstorting: boolean | null;
    /** Indicatie dat opname uit premiedepot bedoeld is voor extra stortingen */
    opnameExtraStortingen: boolean | null;
    /** Percentage vergoeding. */
    vergoedingPercentage: number | null;
    /** Bedrag in premiedepot. */
    premiedepotBedrag: number | null;
    /** Het aantal maanden dat premiedepot duurt. */
    premiedepotDuurInMaanden: number | null;
    /** Het aantal maanden dat inleg betaald moet worden (inclusief eventueel hooglaag) */
    premieDuurInMaanden: number | null;
    /** Het aantal maanden dat inleg betaald moet worden in de hooglaag-constructie */
    duurHooglaagInMaanden: number | null;
    /** Bedrag voor de (lage) inleg */
    inlegBedrag: number | null;
    /** Bedrag voor de hoge inleg */
    hogeInlegBedrag: number | null;
    /** Bedrag voor de aanvangsstorting */
    aanvangsstortingBedrag: number | null;
    /** Extra premiestorting per jaar */
    extraPremiestortingen: ExtraPremiestortingInJaar[] | null;
}

/** Uitvoer van de premiedepot-berekening */
export interface PremiedepotOutput {
    /** Bedrag in premiedepot. */
    premiedepotBedrag: number | null;
    /** Het aantal maanden dat premiedepot duurt. */
    premiedepotDuurInMaanden: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** PremiedepotUitgangspunt Geen = 0, DuurDepot = 1, BedragDepot = 2, VolledigDepot = 3 */
export enum PremiedepotUitgangspunt {
    Geen = "Geen",
    DuurDepot = "DuurDepot",
    BedragDepot = "BedragDepot",
    VolledigDepot = "VolledigDepot",
}

/** Bevat de output van de rendement-berekening. */
export interface RendementOutput {
    resultaat: RendementResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de berekening. */
export interface RendementResultaat {
    /** De berekende rendement */
    rendement: number | null;
    /** Het berekende garantierendement */
    garantierendement: number | null;
    /** Bevat de waardeopbouw per maand van een vermogensrekening. */
    waardeopbouwPerMaand: WaardePerMaand[] | null;
}

/** SoortOpbouwBerekeningOptions Spaar = 1, Belegging = 2, Hybride = 3 */
export enum SoortOpbouwBerekeningOptions {
    Spaar = "Spaar",
    Belegging = "Belegging",
    Hybride = "Hybride",
}

/** Bevat de input voor de lijfrente-uitkeringberekening. */
export interface UitkeringInput {
    /** Bedrag koopsom */
    koopsom: number | null;
    uitkeringstermijn: BetalingsTermijnType;
    /** Rendement over het saldo van de lijfrente-rekening. */
    lijfrentetarief: number;
    /** Aantal maanden uitkering */
    uitkeringsduurInMaanden: number | null;
    /** Looptijd extra uitkering (hoog) */
    uitkeringsduurHoogInMaanden: number | null;
    /** Percentage verhouding hoog/laag */
    verhoudingHoogLaag: number | null;
}

/** Bevat de output van de uitkering-berekening van een lijfrente. */
export interface UitkeringOutput {
    resultaat: UitkeringResultaat | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat het resultaat van de uitkering-berekening van een lijfrente. */
export interface UitkeringResultaat {
    /** Bedrag berekende lijfrente-uitkering */
    uitkeringLijfrente: number;
    /** Bedrag berekende uitkering in de periode van hoge uitkering. */
    uitkeringLijfrenteHoog: number | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

/** Bevat de input voor de vermogensberekening. */
export interface VermogensrekeningInput {
    soortOpbouwBerekening: SoortOpbouwBerekeningOptions;
    /** Opgebouwde waarde. */
    opgebouwdewaarde: number | null;
    /** Datum van de opgebouwde waarde */
    opgebouwdewaardedatum: string | null;
    /** Indicatie of de opgebouwde waarde aan het begin van de maand meegenomen dient te worden */
    opgebouwdKapitaalVooraf: boolean;
    /** Bedrag waarnaartoe of waarmee gerekend moet worden. */
    doelkapitaal: number | null;
    /** Gegarandeerd bedrag waarnaartoe of waarmee gerekend moet worden. */
    garantiekapitaal: number | null;
    /** Het verwachte rendementspercentage van de belegging. */
    rendement: number | null;
    /** Het garantierendement. */
    garantierendement: number | null;
    /** Ingangsdatum van de vermogensrekening */
    ingangsdatum: string;
    /** Looptijd van de vermogensrekening in maanden. */
    looptijdInMaanden: number;
    /** Eerste inleg. */
    eersteInleg: number | null;
    /** Duur van de periode met hoge stortingen in maanden. */
    hoogLaagLooptijdInMaanden: number | null;
    /** Hoge inleg. */
    hoogLaagInlegHoog: number | null;
    /** Het percentage van de inleg waarop het garantierendement van toepassing is. */
    garantiepercentageInleg: number | null;
    /** Het percentage aan kosten dat gehanteerd wordt bij aankoop (inleg). */
    aankoopkostenPercentage: number | null;
    /** Het percentage aan kosten dat gehanteerd wordt bij verkoop (opname). */
    verkoopkostenPercentage: number | null;
    /** Het percentage aan kosten dat gehanteerd wordt bij beheer (waardeopbouw). */
    bekeerskostenPercentage: number | null;
    inleg: PeriodiekBedragInput | null;
    onttrekking: PeriodiekeOnttrekkingInput | null;
    /** Collectie met extra inleggen. */
    extraInleggen: EenmaligBedragInput[] | null;
    /** Collectie met extra onttrekkingen. */
    extraOnttrekkingen: EenmaligBedragInput[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** Bevat de waardeopbouw van een vermogensrekening in een bepaalde maand. */
export interface WaardePerMaand {
    /** Maand waarin de waarde geldt. */
    maand: number;
    /** Waarde aan het begin van de maand. */
    beginwaarde: number;
    /** Totaal aan stortingen in de maand. */
    stortingen: number;
    /** Totaal aan onttrekkingen in de maand. */
    onttrekkingen: number;
    /** Waarde aan het einde van de maand. */
    waarde: number;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}